// Purpose: Keeps DataTable's explicit header and keyboard-row contrast states.
import { createInsetFocusRing } from '../shared.js';

const internalFieldFocusRing = {
  width: '0',
  style: 'none',
  color: 'transparent',
  offset: '0',
  shadow: 'inset {form.field.focus.ring.shadow}',
};

export const dataComponents = {
  datatable: {
    headerCell: {
      focusRing: internalFieldFocusRing,
    },
    colorScheme: {
      light: {
        headerCell: {
          // Keep column labels distinguishable from the white table body.
          background: '{surface.100}',
          hoverBackground: '{surface.200}',
          // PrimeVue uses this state for the actively sorted column.
          selectedBackground: '{surface.200}',
          hoverColor: '{text.hover.color}',
        },
      },
      dark: {
        headerCell: {
          background: '{surface.700}',
          selectedBackground: '{surface.800}',
          // A deeper tint keeps nested purple text actions readable on hover.
          hoverBackground: 'color-mix(in srgb, {surface.700}, {primary.600} 22%)',
          hoverColor: '{text.hover.color}',
          focusRing: {
            shadow: 'inset 0 0 0 0.2rem {focus.ring.color}',
          },
        },
      },
    },
    row: {
      focusRing: createInsetFocusRing(),
    },
  },
};

export default dataComponents;
